import React from "react"
import { useTranslation } from "react-i18next";
import { LookingForWrapper, ProfileContactWrapper, ServicesCitiesWrapper } from "./styled";
import { Box, ButtonDays, HeadingStyled, HeadingStyledLg, HeadingStyledSm, SpanStyled, TextStyled } from "../../styled/Elements";
import { ContactsListing } from "../../../helpers/webConstants";
import { SearchPropIcon } from "../../styled/AllImages";


const LookingFor = () => {
    const {t} = useTranslation();
    return (
        <LookingForWrapper>
            <Box className="lookingForContent">
                <HeadingStyled size="22px" color="var(--white)">
                    {t("Lookingfor")}
                </HeadingStyled>
                <Box className="sRHeadingWrapper">
                    <HeadingStyledLg size="40px" className="sRHeading sRHeadingOne">
                        {t("SubmitRequest")}
                    </HeadingStyledLg>
                    <HeadingStyledLg size="40px" className="sRHeading sRHeadingSec">
                        {t("SubmitRequest")}
                    </HeadingStyledLg>
                </Box>
                <HeadingStyledSm size="22px" color="var(--white)" className="fillOut">
                    {t("Filloutnow")}
                </HeadingStyledSm>
                <img src={SearchPropIcon} alt="search property icon" className="propertySmBannerIcon" />
            </Box>
        </LookingForWrapper>
    )
}

export default LookingFor;